<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
<!--      <div class="col-xl-3">-->
<!--        <BranchStatsPanel />-->
<!--      </div>-->
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">All GL Level Two</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <AllGlLevel2Table></AllGlLevel2Table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * Create Bank Component
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "All GlLevel1",
    meta: [{ name: "All GlLevel1", content: window.__env.app.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "All GlLevel2",

      items: [
        {
          text: "GlLevel2",
          href: "/"
        },
        {
          text: "Create GlLevel2",
          active: true
        }
      ]
    };
  },

  methods: {}
};
</script>
